import { useState } from "react";


export default function DisclaimerBanner() {
  const [visible, setVisible] = useState(true);

  const disclaimer = `The information presented on this site is intended solely for general reference. 
  While we strive to aggregate important notices from various examination boards in one convenient location, 
  students are advised to refer to the official board websites for the most accurate, detailed, 
  and up-to-date information..📚`;

  if (!visible) return null;

  return (
    <div className="text-blue-900 border border-primary-500 rounded-md p-4 mt-14 shadow-md">
        <div className="flex justify-between align-middle">
            <div className="flex items-start"></div>
            <div className="flex italic font-serif font-bold text-xl text-secondary-900">🔔 Disclaimer</div>
            <button onClick={() => setVisible(false)} className="flex ml-4 text-red-700 hover:text-red-900 
                            items-end text-end font-bold text-xl"> X
            </button>
        </div>
        <div className="italic font-serif text-xl">{disclaimer}</div>
        
    </div>
  );
}